import { type FC } from "react";
import { Form } from "semantic-ui-react";
import { ValidatedForm, CopyableInput } from "../../../../../components";
import { SecretInput } from "./SecretInput";
import LabelWithInfoTooltip from "components/labelWithInfoTooltip/labelWithInfoTooltip";
import styles from "./ApiCredentials.module.scss";

export interface Props {
  clientId?: string;
  clientSecret?: string;
  loading?: boolean;
  readonly?: boolean;
  onSecretRegenerate(): void;
}

export const ApiCredentials: FC<Props> = ({ clientId, clientSecret, loading, readonly, onSecretRegenerate }) => {
  return (
    <ValidatedForm disablePreventTransitionPrompt className={styles.root}>
      <Form.Field disabled={loading}>
        <label>Client ID</label>
        <CopyableInput value={clientId} loading={loading} />
      </Form.Field>
      <Form.Field disabled={loading} className={styles.secret}>
        <LabelWithInfoTooltip
          label={"Secret"}
          width={16}
          info={
            "The Secret Key expires after 12 months. It will need to be manually reset at that time by an account administrator."
          }
          labelClass={styles.label}
        />
        <SecretInput value={clientSecret} onRegenerate={onSecretRegenerate} loading={loading} readonly={readonly} />
      </Form.Field>
    </ValidatedForm>
  );
};
